export default __webpack_public_path__ + "static/media/quant_logo.85c1aee3.png";